import React, { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UspStrip from '../components/UspStrip';
import Footer from '../components/Footer';
import konicaMinoltaImg from '../assets/konica-minolta.png';
import aboutWelcomeImg from '../assets/konica-minolta-about.png';

const whyCards = [
  { icon: 'fa-print', title: 'Quality Printing', desc: 'High-quality printing with sharp details and long-lasting finish.' },
  { icon: 'fa-microchip', title: 'Modern Printing Technology', desc: 'We use advanced machines for accurate colors and premium output.' },
  { icon: 'fa-smile', title: 'Customer Satisfaction', desc: 'We focus on understanding customer needs and delivering the best results.' },
  { icon: 'fa-tag', title: 'Competitive Pricing', desc: 'Affordable pricing without compromising on quality.' },
  { icon: 'fa-shipping-fast', title: 'Fast & On-Time Delivery', desc: 'Timely delivery for every order, from small prints to bulk projects.' },
  { icon: 'fa-palette', title: 'Vibrant & Accurate Colors', desc: 'Bright, rich, and true-to-design color printing.' },
  { icon: 'fa-boxes', title: 'Bulk Order Support', desc: 'Special pricing and smooth handling for large quantity orders.' },
  { icon: 'fa-headset', title: 'Quick Customer Support', desc: 'Friendly support team ready to assist with your requirements.' },
  { icon: 'fa-leaf', title: 'Eco-Friendly Printing', desc: 'Using environmentally responsible materials and printing methods.' },
  { icon: 'fa-award', title: '2+ Years Experience', desc: 'Trusted experience in digital printing and branding solutions.' },
  { icon: 'fa-comments', title: 'Quick Response Support', desc: 'Our team is always here to help with your queries.' },
];

const AboutPage: React.FC = () => {
  const [hoveredCardIndex, setHoveredCardIndex] = useState<number | null>(null);

  return (
    <div className="page-fade d-flex flex-column" style={{ minHeight: 'calc(100vh - 68px)' }}>
      <div style={{ flex: 1 }}>
        <div className="breadcrumb-bar">
          <Link to="/">Home</Link> &gt; About Us
        </div>

        {/* ABOUT */}
        <div style={{ padding: '60px 5%', background: 'linear-gradient(135deg, #fff5fb 0%, #fdf2f8 50%, #ffffff 100%)' }}>
          <Container>
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold text-dark" style={{ letterSpacing: '-0.5px' }}>
                About <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Us</span>
              </h2>
              <div style={{ width: '60px', height: '3px', background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', borderRadius: '2px', margin: '20px auto' }}></div>
            </div>

            <Row className="g-5 align-items-center">
              <Col md={6}>
                <div style={{
                  borderRadius: '14px',
                  overflow: 'hidden',
                  boxShadow: '0 12px 40px rgba(233, 30, 140, 0.15)',
                  border: '1px solid #ffe6f0',
                }}>
                  <img src={aboutWelcomeImg} alt="Prathitha Digital Printers" style={{ width: '100%', display: 'block' }} />
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <span style={{
                    display: 'inline-block',
                    background: 'rgba(233, 30, 140, 0.1)',
                    color: '#e91e8c',
                    padding: '6px 14px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '700',
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}>
                    Welcome
                  </span>
                  <h3 className="fw-bold text-dark mb-3" style={{ fontSize: 'clamp(24px, 5vw, 32px)', letterSpacing: '-0.5px' }}>
                    Prathitha Digital<br />
                    <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Printers</span>
                  </h3>
                  <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.8', marginBottom: '16px' }}>
                    We are a leading digital printing service provider committed to delivering high-quality prints with precision and perfection.
                  </p>
                  <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.8', marginBottom: '24px' }}>
                    With advanced printing technology and a skilled team, we ensure vibrant colors, superior finishing and timely delivery for all your printing needs.
                  </p>
                  <Row className="g-3">
                    {['Quality Assurance', 'Advanced Technology', 'Customer First', 'Affordable Prices'].map(f => (
                      <Col xs={6} key={f}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px',
                          background: '#f8f9fb',
                          borderRadius: '8px',
                          fontSize: '13px',
                          fontWeight: '600',
                          color: '#333',
                          transition: 'all 0.3s ease',
                        }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#eff5fb';
                            e.currentTarget.style.transform = 'translateX(4px)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = '#f8f9fb';
                            e.currentTarget.style.transform = 'translateX(0)';
                          }}>
                          <i className="fas fa-check-circle" style={{ color: '#10b981', fontSize: '16px' }}></i>
                          {f}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* TECHNOLOGY SECTION */}
        <div className="tech-section py-5" style={{
          background: 'linear-gradient(180deg, #fafbfe 0%, #f5f7fa 100%)',
          borderTop: '1px solid #eaeef5',
          borderBottom: '1px solid #eaeef5',
        }}>
          <Container>
            <Row className="g-5 align-items-center">
              <Col lg={6} className="order-lg-2">
                <div style={{
                  position: 'relative',
                  borderRadius: '14px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(233, 30, 140, 0.2)',
                  border: '1px solid #ffe6f0',
                }}>
                  <img
                    src={konicaMinoltaImg}
                    alt="Konica Minolta AccurioPress Production Machine"
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    background: 'linear-gradient(180deg, rgba(15,15,45,0) 0%, rgba(15,15,45,0.9) 100%)',
                    padding: '30px 20px 20px',
                    color: 'white',
                  }}>
                    <h4 style={{ margin: 0, fontSize: 'clamp(16px, 3vw, 18px)', fontWeight: 700 }}>Konica Minolta AccurioPress</h4>
                    <p style={{ margin: '5px 0 0', fontSize: '12px', opacity: 0.9 }}>Production Digital Color Press</p>
                  </div>
                </div>
              </Col>
              <Col lg={6} className="order-lg-1">
                <div>
                  <div style={{
                    background: 'rgba(233, 30, 140, 0.1)',
                    color: '#e91e8c',
                    padding: '8px 16px',
                    borderRadius: '30px',
                    fontWeight: '700',
                    fontSize: '12px',
                    display: 'inline-block',
                    marginBottom: '20px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}>
                    <i className="fas fa-microchip me-2"></i> Cutting-Edge Machinery
                  </div>
                  <h2 style={{
                    fontSize: 'clamp(24px, 5vw, 32px)',
                    fontWeight: '800',
                    color: '#1a1a1a',
                    marginBottom: '20px',
                    lineHeight: '1.3',
                    letterSpacing: '-0.5px',
                  }}>
                    Powered by <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Konica Minolta</span> Technology
                  </h2>
                  <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.8', marginBottom: '28px' }}>
                    At Prathitha Digital Printers, we believe that premium quality starts with state-of-the-art technology. That is why our core print shop workflow is powered by the industry-leading <strong>Konica Minolta AccurioPress</strong> production press.
                  </p>

                  <Row className="g-4">
                    {[
                      { icon: 'fa-expand-arrows-alt', title: 'High Precision Alignment', desc: 'Real-time image rotation and skew correction for perfect double-sided print registration.' },
                      { icon: 'fa-palette', title: 'Simitri HD Polymerized Toner', desc: 'Delivers vivid, offset-like color output with half-tone control and clean solid gradients.' },
                      { icon: 'fa-gauge-high', title: 'Incredible Speed & Duty', desc: 'Enables us to handle massive bulk print runs with rapid turnaround times and zero quality drop.' },
                      { icon: 'fa-scroll', title: 'Thick Cardstock Support', desc: 'Handles print media from 62 gsm up to 400 gsm paper weights for textured, kraft, and PVC stock.' },
                    ].map((feature, idx) => (
                      <Col sm={6} key={idx}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '12px',
                          padding: '16px',
                          background: '#fff',
                          borderRadius: '10px',
                          border: '1px solid #eaeef5',
                          transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                          cursor: 'pointer',
                        }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-4px)';
                            e.currentTarget.style.boxShadow = '0 10px 25px rgba(233, 30, 140, 0.12)';
                            e.currentTarget.style.borderColor = '#ffe6f0';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.borderColor = '#eaeef5';
                          }}>
                          <div style={{
                            width: '40px',
                            height: '40px',
                            background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
                            color: '#fff',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '16px',
                            flexShrink: 0,
                            boxShadow: '0 4px 12px rgba(233, 30, 140, 0.2)',
                          }}>
                            <i className={`fas ${feature.icon}`}></i>
                          </div>
                          <div>
                            <h5 style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a1a', marginBottom: '6px' }}>
                              {feature.title}
                            </h5>
                            <p style={{ fontSize: '12px', color: '#777', margin: 0, lineHeight: '1.5' }}>
                              {feature.desc}
                            </p>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* WHY CHOOSE US */}
        <div style={{ padding: '60px 5%' }}>
          <Container>
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold text-dark" style={{ letterSpacing: '-0.5px' }}>
                Why <span style={{ background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Choose</span> Us
              </h2>
              <div style={{ width: '60px', height: '3px', background: 'linear-gradient(90deg, #e91e8c, #3b5bdb)', borderRadius: '2px', margin: '20px auto' }}></div>
              <p className="lead text-muted mt-4" style={{ maxWidth: '600px', margin: '20px auto', fontSize: '15px' }}>
                Discover what makes us the trusted choice for premium digital printing services
              </p>
            </div>

            <Row className="g-4 justify-content-center">
              {whyCards.map((c, idx) => (
                <Col key={c.title} xs={12} sm={6} md={4} lg={3} style={{ flex: '1 1 220px', maxWidth: '280px' }}>
                  <div
                    onMouseEnter={() => setHoveredCardIndex(idx)}
                    onMouseLeave={() => setHoveredCardIndex(null)}
                    style={{
                      height: '100%',
                      background: '#fff',
                      borderRadius: '14px',
                      border: '1px solid #eaeef5',
                      padding: '28px 20px',
                      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      transform: hoveredCardIndex === idx ? 'translateY(-12px)' : 'translateY(0)',
                      boxShadow: hoveredCardIndex === idx
                        ? '0 20px 40px rgba(233, 30, 140, 0.15)'
                        : '0 4px 15px rgba(0, 0, 0, 0.08)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <div style={{
                      width: '60px',
                      height: '60px',
                      background: hoveredCardIndex === idx
                        ? 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)'
                        : 'rgba(233, 30, 140, 0.1)',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '20px',
                      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      transform: hoveredCardIndex === idx ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0)',
                      boxShadow: hoveredCardIndex === idx ? '0 8px 20px rgba(233, 30, 140, 0.3)' : 'none',
                    }}>
                      <i
                        className={`fas ${c.icon}`}
                        style={{
                          fontSize: '24px',
                          color: hoveredCardIndex === idx ? '#fff' : '#e91e8c',
                          transition: 'color 0.3s ease',
                        }}
                      ></i>
                    </div>

                    <h5 style={{
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '700',
                      color: '#1a1a1a',
                      marginBottom: '12px',
                      letterSpacing: '-0.3px',
                    }}>
                      {c.title}
                    </h5>

                    <p style={{
                      fontSize: '13px',
                      color: '#666',
                      lineHeight: '1.6',
                      margin: 0,
                    }}>
                      {c.desc}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>

      <UspStrip />
      <Footer />
    </div>
  );
};

export default AboutPage;
